export default "__VITE_ASSET__9c6c7430__"